import { FLAG } from 'Utilities/analytics/optimizely/constants';

import { useBinaryExperiment } from '../useBinaryExperiment';

export const useFinanceExperiment = () => {
  const isFinanceExperimentOn = useBinaryExperiment(FLAG.MW_5_3_HERO_FINANCE_QUESTION, { triggerExperiment: true });

  return { isFinanceExperimentOn };
};
